export default "__VITE_ASSET__j83M_G2p__"